const ACTIVE_CLASS = 'wwa-scrollbar-active';
const IDLE_MS = 1200;
const POINTER_THROTTLE_MS = 120;

const hideTimers = new WeakMap();

function markActive(element) {
  if (!(element instanceof Element)) return;
  element.classList.add(ACTIVE_CLASS);
  clearTimeout(hideTimers.get(element));
  hideTimers.set(
    element,
    setTimeout(() => element.classList.remove(ACTIVE_CLASS), IDLE_MS)
  );
}

function isScrollable(element) {
  if (element.scrollHeight <= element.clientHeight && element.scrollWidth <= element.clientWidth) {
    return false;
  }
  const style = getComputedStyle(element);
  return /(auto|scroll)/.test(style.overflowY + style.overflowX);
}

function markScrollableAncestors(target) {
  let element = target instanceof Element ? target : null;
  while (element && element !== document.body) {
    if (isScrollable(element)) markActive(element);
    element = element.parentElement;
  }
}

export function installScrollbarAutoHide() {
  if (typeof document === 'undefined' || document.documentElement.dataset.scrollbarAutoHide) return;
  document.documentElement.dataset.scrollbarAutoHide = 'true';

  document.addEventListener(
    'scroll',
    (event) => {
      const target = event.target === document ? document.scrollingElement : event.target;
      markActive(target);
    },
    { capture: true, passive: true }
  );

  let lastPointerTarget = null;
  let lastPointerTime = 0;
  document.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType === 'touch') return;
      const now = Date.now();
      if (event.target === lastPointerTarget && now - lastPointerTime < POINTER_THROTTLE_MS) return;
      lastPointerTarget = event.target;
      lastPointerTime = now;
      markScrollableAncestors(event.target);
    },
    { passive: true }
  );
}
